import { apiClient, ApiResponse } from '@/features/shared/api/apiClient';
import type { UserWithRolesDto, UserRoleHistoryDto } from '../types';

class UserRoleService {
  async getUsersWithRoles(): Promise<UserWithRolesDto[]> {
    const { data } = await apiClient.get<ApiResponse<UserWithRolesDto[]>>('/authorization/users');
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch users with roles');
  }

  async getUserRoleHistory(userId: number): Promise<UserRoleHistoryDto[]> {
    const { data } = await apiClient.get<ApiResponse<UserRoleHistoryDto[]>>(
      `/authorization/users/${userId}/role/history`
    );
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch user role history');
  }

  async updateUserRoles(userId: number, roleIds: number[]): Promise<void> {
    const { data } = await apiClient.put<ApiResponse<object>>(
      `/authorization/users/${userId}/roles`,
      { roleIds }
    );
    if (!data.success) {
      throw new Error(data.message || 'Failed to update user roles');
    }
  }
}

export const userRoleService = new UserRoleService();
